import api from "../api/axios";
import {
  CreateDepartmentPayload,
  UpdateDepartmentPayload,
} from "../Types/CompanyProfile/Department";

import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export const DEPARTMENT_QUERY_KEY = ["departments"];
export const VIEW_DEPARTMENT_QUERY_KEY = ["view-departments"];

export const departmentService = {
  createDepartment: async (payload: CreateDepartmentPayload) => {
    const response = await api.post(`api/departments`, payload);
    return response.data;
  },
  updateDepartment: async (id: number, payload: UpdateDepartmentPayload) => {
    const response = await api.patch(`api/departments/${id}`, payload);
    return response.data;
  },
  toggleStatus: async (id: number) =>
    requestWithRefresh(() =>
      api
        .patch(
          `api/departments/${id}/toggle-status`,
          {},
          { headers: getAuthHeaders() },
        )
        .then((res) => res.data),
    ),
  getAllViewDepartment: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-departments`, { headers: getAuthHeaders() })
        .then((res) => res.data),
    ),
  getAllViewDepartmentById: async (id: number) =>
    requestWithRefresh(() =>
      api
        .get(`api/view-departments/${id}`, { headers: getAuthHeaders() })
        .then((res) => res.data),
    ),
  getAllViewDepartmentByCompany: async (code: string) =>
    requestWithRefresh(() =>
      api
        .get(`api/view-departments/company/${code}`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
  getAllViewDepartmentByDiv: async (id: number) =>
    requestWithRefresh(() =>
      api
        .get(`api/view-departments/division/${id}`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
